import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryNewModal(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-new-modal',
    alias: 'factoryNewModal',
    loader: i18nLoader,
  });
}
